export default __webpack_public_path__ + "static/media/ic_dai_40.ff92bfa1.svg";